import Typography from '~/shared/components/Typography';
import Button from '~/shared/components/ButtonsV2';
import FilterIcon from '~/shared/assets/icons/filter.svg';
import CancelIcon from '~/shared/assets/icons/cancel.svg';

type ButtonVariant = 'primary' | 'secondary' | 'third' | 'text';
type ButtonSize = 'sm' | 'md' | 'md-responsive' | 'lg';

interface FilterButtonProps {
  activeFilterCount: number;
  onOpen: () => void;
  onClearAll: () => void;
  label?: string;
  className?: string;
  size?: ButtonSize;
  variant?: ButtonVariant;
}

export default function FilterButton({
  activeFilterCount,
  onOpen,
  onClearAll,
  label = 'Filters',
  className,
  size = 'md-responsive',
  variant = 'third',
}: FilterButtonProps) {
  return (
    <Button
      size={size}
      variant={variant}
      className={`flex gap-1! items-center relative transition-all duration-800 w-auto group ${
        className ?? ''
      }`}
      leftIcon={
        <FilterIcon
          className={`size-5 aspect-square group-hover:stroke-primary-400 group-hover:stroke-2 ${
            activeFilterCount > 0 ? 'stroke-primary-400 stroke-2 ' : 'stroke-primary-900'
          }`}
        />
      }
      rightIcon={
        activeFilterCount > 0 && (
          <div
            className="px-[6px] h-[22px] bg-gray-200 hover:bg-gray-300 rounded transition-colors duration-150 flex gap-0.5 items-center"
            onClick={(e) => {
              e.stopPropagation();
              onClearAll();
            }}
            title="Clear all filters"
          >
            <span
              className="grid place-items-center text-primary-900 text-xs font-semibold"
              data-testid="active-filter-count"
            >
              {activeFilterCount}
            </span>
            <CancelIcon className="size-4 stroke-gray-700" />
          </div>
        )
      }
      onClick={onOpen}
    >
      <Typography variant="p3" color="text-primary-900" className="whitespace-nowrap">
        {label}
      </Typography>
    </Button>
  );
}
